export const LMS_CERTIFIED_USERS_RESET_STATE = 'LMS_CERTIFIED_USERS_RESET_STATE';
export const LMS_CERTIFIED_USERS_CURRENT_ITEM = 'LMS_CERTIFIED_USERS_CURRENT_ITEM';

export const LMS_CERTIFIED_USERS_REQUEST_LOADING = 'LMS_CERTIFIED_USERS_REQUEST_LOADING';
export const LMS_CERTIFIED_USERS_REQUEST_SUCCESS = 'LMS_CERTIFIED_USERS_REQUEST_SUCCESS';
export const LMS_CERTIFIED_USERS_REQUEST_FAILED = 'LMS_CERTIFIED_USERS_REQUEST_FAILED';

export const LMS_CERTIFIED_USERS_CURRENT_ACTION = 'LMS_CERTIFIED_USERS_CURRENT_ACTION';
export const LMS_CERTIFIED_USERS_RESET_ACTION = 'LMS_CERTIFIED_USERS_RESET_ACTION';
